import { combineReducers } from 'redux';
import { createReducers } from '../../ducksHelpers';
import { providerPayoutsSettings } from './providerPayouts';
import { providerPayoutSettings } from './providerPayout';

const settingList = [
  providerPayoutsSettings,
  providerPayoutSettings,
];

const providerPayoutsReducer = combineReducers(createReducers(settingList));

export default providerPayoutsReducer;
